import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises";

export default {
  fetch() {
    return http.get(`${resource}/ports`);
  },
};
